import React from 'react';
import { compose } from 'ramda';

import styleFile from './AvailRoomDetailPreferencesToggle.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Button from '@synergycms_core/components/generic/Button';
import classnames from 'classnames/bind';

class AvailRoomDetailPreferencesToggle extends React.Component {
  static displayName = 'AvailRoomDetailPreferencesToggle';
  constructor(props) {
    super(props);
    this.cx = classnames.bind(styleFile);
  }

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    return (
      <div className={theme.computedInnerStyle}>
        <Button
          onClick={config.togglePreferences}
          richText={{
            text: '_%personalizar habitación%_',
            innerStyle: [this.cx({ class1: config.editPreferences }), 'mainColor'],
            translate: true,
            ucFirst: true,
            icon: {
              svg: 'preferences',
              innerStyle: [classes.preferencesSvg, 'mainColorSvg']
            }
          }}
        />
      </div>
    );
  }
}

export default compose(
  PropertyManager(['togglePreferences', 'editPreferences']),
  withThemeJSS({ styleFile })
)(AvailRoomDetailPreferencesToggle);
